import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=28db3ac6&"
import script from "./Duration.vue?vue&type=script&lang=ts&"
export * from "./Duration.vue?vue&type=script&lang=ts&"
import style0 from "./Duration.vue?vue&type=style&index=0&id=28db3ac6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports